'use client';

import { useState, useEffect } from 'react';

/**
 * Returns `true` after the component has mounted on the client.
 * Use this to guard against hydration mismatches when reading
 * persisted state (e.g. Zustand `persist` middleware) that may
 * differ between server defaults and client localStorage values.
 */
export function useHasMounted(): boolean {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
}
